import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PromotionService } from '../../../services/promotion.service';
import { PromotionPriceComponent } from '../promotion-price/promotion-price.component';
import { PromotionItemComponent } from '../promotion-item/promotion-item.component';
import { MenuService } from '../../../services/menu.service';
import { Constants } from '../../../model/common.model';
import { PanelModule } from '../../../modules/panel.module';
import { UiSettingsComponent } from '../../ui-settings/ui-settings.component';

@Component({
  selector: 'brt-promotion-save',
  standalone: true,
  imports: [PanelModule, UiSettingsComponent, PromotionItemComponent, PromotionPriceComponent],
  templateUrl: './promotion-save.component.html',
  styleUrl: './promotion-save.component.scss'
})
export class PromotionSaveComponent {
  basePath = this.route.snapshot.data['basePath'] || '/';
  businessId: any;
  promotionId: any;
  promotion: any;
  menus: any[];
  templates = ['SpecialOffer', 'BuyOneGetOneFree', 'MixedDeal', 'FreeOffer'];
  template: string;
  constructor(private route: ActivatedRoute, private router: Router, menuService: MenuService, private promotionService: PromotionService) {
    route.params.subscribe(async params => {
      this.businessId = params['bid'];
      this.promotionId = params['id'];
      menuService.searchMenu({ BusinessId: this.businessId }).then(result => this.menus = result.List);
      await this.load();
    });
  }
  orderTypes = Constants.OrderTypes;
  weekDays = Constants.WeekDays;

  // A "Buy one get one" offer with a Fixed Price of 0 but without DiscountCheapest
  // zeroes every selected item, so the whole order becomes free. That is almost
  // always a mistake (e.g. a Buy-One-Get-One-Free set up without ticking the
  // "cheaper item" option), so warn about it while the promotion is being edited.
  get makesWholeOfferFree(): boolean {
    const price = this.promotion?.Price;
    return !!price
      && price.DiscountType === 'FixPrice'
      && (Number(price.Value) || 0) === 0
      && !this.promotion?.DiscountCheapest
      && (this.promotion?.Items?.length ?? 0) >= 2;
  }

  async load() {
    if (!this.promotionId)
      this.promotion = {
        BusinessId: this.businessId,
        ServingHours: [{ OrderType: 'Default', Days: Constants.WeekDays, StartTime: '08:00:00', EndTime: '22:00:00' }],
        Conditions: []
      };
    else
      this.promotion = await this.promotionService.getPromotion(this.promotionId);
  }

  async save(navigate = true) {
    await this.promotionService.savePromotion(this.promotion);
    if (navigate) {
      if (window.history?.length) window.history.back()
      else await this.router.navigate([this.basePath, 'promotion', this.businessId].filter(_ => _));
    }
  }
}
